module.exports = __webpack_public_path__ + "img/bell-plus.b9792cb3.svg";